import { FormBuilder } from "@/components/form-builder";
import { SignUpFormData } from "./schemas";
import { signUpFormFields } from "./constants";
import { mapFormToRegister } from "../../utils/map-form";
import { useEffect, useState } from "react";
import { SuccessDialog } from "../signup-dialog";
import { useRegisterUser } from "@/services/queries/useUsers";

export function SignUpForm() {
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);

  const { mutateAsync: register, isPending, isSuccess } = useRegisterUser()

  useEffect(() => {
    if (isSuccess) {
      setOpenSuccessDialog(true);
    }
  }, [isSuccess]);

  return (
    <>
      <FormBuilder<SignUpFormData>
        formId="sign-up-form"
        fields={signUpFormFields}
        submitLabel="Inscreva-se"
        submitPosition="full"
        isLoading={isPending}
        onSubmit={async (data) => {
          await register(mapFormToRegister(data));
        }}
      />

      <SuccessDialog open={openSuccessDialog} onOpenChange={setOpenSuccessDialog} />
    </>
  )
}

